import e from"./image";export{StyledImageContainer,StyledImage,StyledImageSkeleton}from"./image.styles";export default e;